export default "__VITE_ASSET__BCLhxLko__"